/**
 * フェードインアニメーション機能
 * js-fadeInクラスが付いた要素をスクロール時にフェードイン表示
 * 要素が表示領域に50px入ると、Y座標-100pxの位置から上に移動しながらフェードイン
 */
/* global IntersectionObserver */
export const fadeIn = () => {
	const fadeInElements = document.querySelectorAll('.js-fadeIn')

	if (fadeInElements.length === 0) {
		return
	}

	// 各要素を初期状態に設定
	fadeInElements.forEach((element) => {
		element.style.opacity = '0'
		element.style.transform = 'translateY(100px)'
		element.style.transition = 'opacity 1s ease-out, transform 1s ease-out'
	})

	// Intersection Observerのオプション
	const observerOptions = {
		root: null, // ビューポートを基準にする
		rootMargin: '-80px 0px', // 要素が表示領域に80px入ったら発火
		threshold: 0, // 要素が少しでも見えたら発火
	}

	// Intersection Observerのコールバック
	const observerCallback = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// 要素が表示領域に入ったらフェードイン
				entry.target.style.opacity = '1'
				entry.target.style.transform = 'translateY(0)'

				// 一度表示されたら監視を解除（パフォーマンス向上）
				observer.unobserve(entry.target)
			}
		})
	}

	// Intersection Observerを作成
	const observer = new IntersectionObserver(observerCallback, observerOptions)

	// 各要素を監視対象に追加
	fadeInElements.forEach((element) => {
		observer.observe(element)
	})
}
